




























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditResource from "./edit-resource.vue";

class PageResourceRequest extends PageRequest {
  keyword: string;
  ExternalType: number = 0;
  classTypeId: number = 2;
  multiTypeName: string = "资源";
  parentId?: number;
  GradeType: number = 0;
  parentName: string = "上级分类";
  categoryId?: number;
  isAudit: boolean = true;
  screenWidth: number = document.body.clientWidth;
}

@Component({
  components: { EditResource },
})
export default class Resources extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageResourceRequest = new PageResourceRequest();
  editModalShow: boolean = false;
  multiTypes: any = [];
  data: any = [];
  showme: string = "测试";
  valueArray: any = [];

  searchGetpage() {
    this.$store.state.resource.currentPage = 1;
    this.getpage();
  }
  cascaderSelect(value, selectedData) {
    if (value.length > 0) {
      this.pagerequest.categoryId = selectedData[selectedData.length - 1].value;
      this.pagerequest.parentName = selectedData[selectedData.length - 1].label;
    } else {
      this.pagerequest.categoryId = null;
    }
    this.$store.state.resource.currentPage = 1;
    this.getpage();
  }
  handleRefresh() {
    this.loadCascaders();
  }
  get list() {
    return this.$store.state.resource.list;
  }
  get loading() {
    return this.$store.state.resource.loading;
  }
  create() {
    this.editModalShow = true;
    this.$store.state.resource.editResource.classTypeId = this.pagerequest.classTypeId;
    this.$store.state.resource.editResource.multiTypeName = this.pagerequest.multiTypeName;
    this.$store.state.resource.editResource.parentId = this.pagerequest.parentId;
    this.$store.state.resource.editResource.parentName = this.pagerequest.parentName;
  }
  selectChange(item) {
    this.pagerequest.classTypeId = item.id;
    this.pagerequest.multiTypeName = item.text;
    this.valueArray = [];
    this.pagerequest.parentId = null;
    this.loadCascaders();
  }
  pageChange(page: number) {
    this.$store.commit("resource/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("resource/setPageSize", pagesize);
    this.getpage();
  }
  async loadCascaders() {
    await this.$store
      .dispatch({
        type: "resource/getCascader",
        data: { classTypeId: this.pagerequest.classTypeId },
      })
      .then((result) => {
        this.data = this.$store.state.resource.cascaders.items;
        if (sessionStorage.getItem("isGeneral") == "true") {
          if (this.data.length) {
            this.pagerequest.categoryId = this.data[0].value;
            this.pagerequest.parentName = this.data[0].label;
            this.valueArray.push(this.data[0].value);
          }
        }
        this.$store
          .dispatch({
            type: "resource/getTopicCascader",
            data: { classTypeId: 6 },
          })
          .then((result) => {
            this.getpage();
          });
      });
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "resource/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.resource.pageSize;
  }
  get totalCount() {
    return this.$store.state.resource.totalCount;
  }
  get currentPage() {
    return this.$store.state.resource.currentPage;
  }
  getTypeName(classTypeId) {
    for (var item of this.multiTypes) {
      if (item.id === classTypeId) return item.text;
    }
  }
  columns = [
    {
      title: "分类",
      width: 130,
      key: "categoryName",
    },
    {
      title: "标题",
      key: "title",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                title: params.row.title,
                href: "http://www.sxjy.cq.cn/natural/" + params.row.id,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.title,
          ),
        ]);
      },
    },
    {
      title: "点击",
      width: 65,
      key: "clickVolume",
    },
    {
      title: "K币",
      width: 65,
      key: "readingPoints",
    },
    {
      title: "类型",
      width: 65,
      key: "resourceCategoryName",
    },
    {
      title: "范围",
      width: 65,
      render: (h: any, params: any) => {
        // 先定义类型对应的文字和颜色，便于维护
        const typeConfig = {
          0: { text: "不限", color: "#2d8cf0" },
          1: { text: "对外", color: "" },
          2: { text: "对内", color: "red" },
          3: { text: "内外", color: "#2d8cf0" }, // 3-内外沿用0的颜色，可根据需求调整
        };
        // 获取当前行的类型配置，兜底避免无匹配
        const currentConfig = typeConfig[params.row.externalType] || {
          text: "",
          color: "",
        };

        return h(
          "span",
          {
            style: {
              color: currentConfig.color,
            },
          },
          currentConfig.text,
        );
      },
    },
    {
      title: "推荐",
      width: 65,
      render: (h: any, params: any) => {
        return h("span", params.row.isRecommend ? this.L("Yes") : this.L("No"));
      },
    },
    {
      title: "序号",
      width: 65,
      key: "sortNo",
    },
    {
      title: "发布人",
      width: 80,
      key: "creatorUserName",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                href:
                  "http://www.sxjy.cq.cn/usershow/" + params.row.creatorUserId,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.creatorUserName,
          ),
        ]);
      },
    },
    {
      title: this.L("CreationTime"),
      width: 100,
      key: "creationTime",
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString(),
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 140,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  params.row.multiTypeName = this.getTypeName(
                    params.row.classTypeId,
                  );
                  this.$store.commit("resource/edit", params.row);
                  if (!params.row.parentName)
                    this.$store.state.resource.editResource.parentName =
                      "一级分类";
                  this.edit();
                },
              },
            },
            this.L("Edit"),
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                // disabled: params.row.id < 3,
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L(
                      "你确定要删除，【" + params.row.name + "】吗？",
                    ),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "resource/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete"),
          ),
        ]);
      },
    },
  ];
  columns2 = [
    {
      title: "标题",
      key: "title",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                title: params.row.title,
                href: "http://www.sxjy.cq.cn/natural/" + params.row.id,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.title,
          ),
        ]);
      },
    },
    {
      title: "点击",
      width: 65,
      key: "clickVolume",
    },
    {
      title: "类型",
      width: 65,
      key: "resourceCategoryName",
    },

    {
      title: "发布人",
      width: 80,
      key: "creatorUserName",
      render: (h, params) => {
        return h("span", [
          h(
            "A",
            {
              attrs: {
                target: "_blank",
                href:
                  "http://www.sxjy.cq.cn/usershow/inhome/" +
                  params.row.creatorUserId,
              },
              props: {
                type: "info",
                size: "small",
              },
              style: { "font-size": "12px", color: "#2c3e50" },
            },
            params.row.creatorUserName,
          ),
        ]);
      },
    },
    {
      title: this.L("CreationTime"),
      width: 100,
      key: "creationTime",
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString(),
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 140,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  params.row.multiTypeName = this.getTypeName(
                    params.row.classTypeId,
                  );
                  this.$store.commit("resource/edit", params.row);
                  if (!params.row.parentName)
                    this.$store.state.resource.editResource.parentName =
                      "一级分类";
                  this.edit();
                },
              },
            },
            this.L("Edit"),
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                // disabled: params.row.id < 3,
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L(
                      "你确定要删除，【" + params.row.name + "】吗？",
                    ),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "resource/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete"),
          ),
        ]);
      },
    },
  ];
  async created() {
    this.$store.state.resource.currentPage = 1;
    this.loadCascaders();
  }
}
